import { InboxEntryUnread, WebSocketEntityType } from '@this+that/models';
import log from 'loglevel';

import { useEntitySync } from './useEntitySync';
import {
  useRefreshUnreads,
  useUnreadStore,
} from '../../../store/Inbox/Unread/useUnreadStore';

export function useUnreadSync() {
  const addUnread = useUnreadStore((s) => s.addUnread);
  const markAsRead = useUnreadStore((s) => s.markAsRead);
  const { refreshUnreads } = useRefreshUnreads();

  const withUnreadKey = (
    item: InboxEntryUnread,
    op: (inboxEntryId: string, taskGroupId: string) => void,
  ) => {
    if (item.inboxEntryId && item.taskGroupId) {
      op(item.inboxEntryId, item.taskGroupId);
    } else {
      log.warn('[UnreadSync] Received incomplete unread item', item);
    }
  };

  useEntitySync<InboxEntryUnread>(WebSocketEntityType.InboxEntryUnread, {
    onInsert: (item) => withUnreadKey(item, addUnread),
    onModify: (item) => withUnreadKey(item, addUnread),
    onRemove: (item) => withUnreadKey(item, markAsRead),
    onReconnect: async () => {
      log.info('[UnreadSync] Reconnected after long pause, refreshing unreads');
      try {
        await refreshUnreads();
      } catch (error) {
        log.error('[UnreadSync] Failed to refresh unreads:', error);
      }
    },
  });
}
